module.exports = __webpack_public_path__ + "img/valencia_toda_la_ciudad.85d0e107.jpg";